export function getDomainUrl(data: string) {
  const a = document.createElement('a');
  a.href = data;
  return `https://${a.hostname}`;
}
